<template>
  <form v-on:submit.prevent="submitForm()">
    <div data-error class="alert alert-danger my-1 px-2 py-1" role="alert">{{ errors.form.hash }}</div>

    <div class="my-1">
      <div class="input-group">
        <div class="input-group-text"><font-awesome-icon icon="fa-solid fa-key" /></div>
        <input
          type="password"
          class="form-control"
          placeholder="новый пароль"
          name="password"
          v-model="form.password" />
      </div>
      <div data-error class="alert alert-danger my-1 px-2 py-1" role="alert">{{ errors.form.password }}</div>
    </div>

    <div class="my-1">
      <div class="input-group">
        <div class="input-group-text"><font-awesome-icon icon="fa-solid fa-key" /></div>
        <input
          type="password"
          class="form-control"
          placeholder="повторить новый пароль"
          name="password_confirmation"
          v-model="form.password_confirmation" />
      </div>
      <div data-error class="alert alert-danger my-1 px-2 py-1" role="alert">
        {{ errors.form.password_confirmation }}
      </div>
    </div>

    <div data-error class="alert alert-info mb-1 mt-3 px-2 py-1" role="alert">{{ errors.form.common }}</div>

    <div class="mt-2 mb-1 text-end">
      <button type="submit" class="btn btn-primary">
        <font-awesome-icon icon="fa-solid fa-check"></font-awesome-icon> Сохранить
      </button>
    </div>
  </form>
</template>

<script>
import axios from 'axios';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCheck, faKey } from '@fortawesome/free-solid-svg-icons';
library.add(faCheck, faKey);

export default {
  data: function () {
    return {
      isLoading: false,
      //
      form: {
        _token: this.csrf,
        hash: '',
        password: '',
        password_confirmation: '',
      },
      errors: {
        form: {
          hash: '',
          password: '',
          password_confirmation: '',
          common: '',
        },
      },
    };
  },
  props: {
    csrf: {
      type: String,
      default: '',
    },
  },
  mounted() {
    const searchURL = new URL(window.location);
    this.form.hash = searchURL.searchParams.get('hash');
  },
  components: {
    FontAwesomeIcon,
  },
  methods: {
    submitForm() {
      // убрать старые ошибки
      Object.keys(this.errors.form).forEach((key) => {
        this.errors.form[key] = '';
      });

      if (this.form.password === '') {
        this.errors.form.password = 'Нужно ввести новый пароль.';

        return false;
      }

      if (this.form.password_confirmation === '') {
        this.errors.form.password_confirmation = 'Нужно повторно ввести новый пароль.';

        return false;
      }

      if (this.form.password !== this.form.password_confirmation) {
        this.errors.form.password_confirmation = 'Пароли должны совпадать.';

        return false;
      }

      this.isLoading = true;

      axios
        .post(`/evocms-user/reset-password`, this.form)
        .then((res) => {
          const { data } = res;

          // ??? надо?
          if (data.message !== '') {
            this.$bs5utils.Snack.show('info', data.message, this.$store.getters.delay.info);
          }

          if (data.status == 'ok') {
            this.errors.form.common = 'Новый пароль успешно сохранён.';

            this.form.password = '';
            this.form.password_confirmation = '';
            this.form.hash = '';
          }
          if (data.status == 'error') {
            const errors = data.errors || {};
            const fieldErrors = errors.validation || {};
            const customErrors = errors.customErrors || {};
            const commonErrors = errors.common || [];

            Object.keys(fieldErrors).forEach((key) => {
              this.errors.form[key] = fieldErrors[key].join(' ');
            });

            Object.keys(customErrors).forEach((key) => {
              this.errors.form[key] = fieldErrors[key].join(' ');
            });

            this.errors.form['common'] = commonErrors.join(' ');
          }
        })
        .catch((err) => {
          this.errors.form['common'] = 'Ошибка на сервере, обновите страницу и попробуйте ещё раз.';
          console.error(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
